// extracted by mini-css-extract-plugin
export default {"menu":"notifications_menu__MRQIe","inner":"notifications_inner__rsGhW"};